import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Users, ArrowRight } from "lucide-react";

export function CharacterLanding() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/projects").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);
  return (
    <div>
      <div className="mb-2 font-mono text-[11px] uppercase tracking-[0.25em] text-amber-500/70">Phase 3 · Character Studio</div>
      <h1 className="font-serif text-4xl tracking-tight text-slate-100">Character Studio</h1>
      <p className="mt-2 text-sm text-slate-400">Choose a production to detect and manage its cast.</p>
      {rows === null ? (
        <div className="flex items-center justify-center py-24"><Loader2 className="h-6 w-6 animate-spin text-amber-500" /></div>
      ) : rows.length === 0 ? (
        <div className="mt-10 flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-[#12161f]/40 py-24 text-center">
          <Users className="mb-3 h-8 w-8 text-amber-400" /><p className="text-slate-400">Create a production and import its manuscript first.</p>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {rows.map((p) => (
            <button key={p.id} data-testid={`character-project-${p.id}`} onClick={() => navigate(`/studio/projects/${p.id}/characters`)}
              className="group flex items-center justify-between rounded-xl border border-border bg-[#12161f] p-5 text-left transition-all hover:border-amber-500/40">
              <h3 className="font-serif text-xl text-slate-100">{p.title}</h3>
              <ArrowRight className="h-4 w-4 text-slate-600 transition-transform group-hover:translate-x-1 group-hover:text-amber-400" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
